import { combineReducers } from 'redux'
import DefaultReducers, { search } from 'reducers'
import algoliaReducer from 'reducers/algolia2/data'
const Reducer = combineReducers({ ...DefaultReducers, algolia: algoliaReducer, search })
export default Reducer